import React, { useState, useRef } from "react";
import useClickOutside from "../../hooks/useClickOutside";

const Tooltip = ({ children, content }) => {
    const [isOpen, setIsOpen] = useState(false);
    const tooltipRef = useRef(null);
    const triggerRef = useRef(null);

    useClickOutside([tooltipRef, triggerRef], () => {
        setIsOpen(false);
    });

    return (
        <div className="tooltip" ref={triggerRef}>
            <button
                className="tooltip__trigger"
                onClick={() => setIsOpen(!isOpen)}
                onMouseEnter={() => setIsOpen(true)}
                onMouseLeave={() => setIsOpen(false)}
                aria-label="More information"
            >
                {children}
            </button>
            {isOpen && (
                <div className="tooltip__content" ref={tooltipRef}>
                    <div className="tooltip__content__inner">{content}</div>
                    <div className="tooltip__content__arrow" />
                </div>
            )}
        </div>
    );
};

export default Tooltip;
